import React, { useState } from "react";
import RealEstateCard from "./RealEstateCard";
import {
  Grid,
  Box,
  Pagination,
  useMediaQuery,
  Button,
  CircularProgress,
} from "@mui/material";

import useAllPropertiesData from "../../../../utils/hooks/usePropertyData";
import { ContactMail } from "@mui/icons-material";
import { Link } from "react-router-dom";

const RealEstateGrid = ({ isRoom = false }) => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const itemsPerPage = isMobile ? 3 : 6; // Numero di card per pagina
  const [currentPage, setCurrentPage] = useState(1);
  const { propertiesData, loading } = useAllPropertiesData();
  const indexOfLastProperty = currentPage * itemsPerPage;
  const indexOfFirstProperty = indexOfLastProperty - itemsPerPage;
  const currentProperties = propertiesData.slice(
    indexOfFirstProperty,
    indexOfLastProperty
  );

  // Gestisce il cambiamento della pagina
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  if (loading) {
    // Mostra un CircularProgress mentre i dati sono in fase di caricamento
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="70vh"
      >
        <Box
          width="100px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress
            size={40}
            sx={{
              color: "#0c6b8b",
            }}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        zIndex: 100000000,
        justifyItems: "center",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: isMobile ? undefined : "30px 20px",
      }}
    >
      <Box display="flex" justifyContent="center" mb={isMobile ? 7 : 9}>
        <Pagination
          count={Math.ceil(propertiesData.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="info"
        />
      </Box>
      <Grid
        width={"100%"}
        sx={{
          zIndex: 100000000,
        }}
        container
        spacing={isMobile ? 1 : 5}
        justifyContent="center"
        alignItems="center"
      >
        {currentProperties.map((property) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={property.id}
            sx={{ justifyItems: "center" }}
          >
            <RealEstateCard {...property} />
          </Grid>
        ))}
      </Grid>
      <Box display={isRoom ? "flex" : "none"} justifyContent="center" mt={8}>
        <Pagination
          count={Math.ceil(propertiesData.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="info"
        />
      </Box>
      <Button
        component={Link} // Usa Link per fare navigazione
        to="/immobili" // Imposta il percorso di destinazione
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          display: isRoom ? "none" : undefined,
          backgroundColor: "#0C6D8D",
          width: isMobile ? "60vw" : "20vw",
          maxWidth: "200px",
          margin: "80px auto 30px auto",
        }}
        startIcon={<ContactMail />}
      >
        Tutti gli annunci
      </Button>
    </Box>
  );
};

export default RealEstateGrid;
